import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationTR from './locales/tr/translation.json';
import translationFR from './locales/fr/translation.json';

const resources = {
  tr: {
    translation: translationTR
  },
  fr: {
    translation: translationFR
  }
};

i18n
  .use(LanguageDetector) // Dili tarayıcıdan algıla
  .use(initReactI18next) // React ile bağla
  .init({
    resources,
    lng: 'fr', // Varsayılan olarak Fransızca seçili gelsin
    fallbackLng: 'fr', // Yedek dil
    returnEmptyString: true, // Boş string ("") geçerli bir çeviri olarak kabul edilsin
    interpolation: {
      escapeValue: false // React XSS koruması sağladığı için gerek yok
    }
  });

export default i18n;